import * as React from "react";
const RightArrow = (props) => (
  <svg
    width={16}
    height={13}
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 11.364L15 6.36401L10 1.36401"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M1.57422 6.36377L13.6693 6.36377"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default RightArrow;
